import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import InvoiceValidator from 'redux/modules/invoice/invoice-validator';
import AgreementDraftModal from './agreement-draft-modal';
import { AgreementDraftService } from 'frilans-finans';
var _ = require('lodash');

class AgreementDraft extends React.Component {

  static propTypes = {
    invoice: PropTypes.object.isRequired,
    i18n: PropTypes.object.isRequired
  };

  static contextTypes = {
    user: PropTypes.object.isRequired
  };

  constructor (props, context) {
    super(props, context);

    this.state = {
      agreementDraft: [],
      index: 0,
      showModal: false,
      fetchError: false
    };

    this.toggleModal = this.toggleModal.bind(this);
  }

  componentDidMount () {
    this.fetchDraft(this.props.invoice);
  }

  componentWillReceiveProps (nextProps) {
    // Check for diffs among the props we are interested in
    if (nextProps.invoice.customerId !== this.props.invoice.customerId ||
      nextProps.invoice.specification !== this.props.invoice.specification ||
      nextProps.i18n.locale !== this.props.i18n.locale ||
      !_.isEqual(nextProps.invoice.invoiceDate, this.props.invoice.invoiceDate)) {
      this.fetchDraft(nextProps.invoice);
    }
  }

  fetchDraft (invoice) {
    if (this.allParamsSet(invoice)) {
      this.startRequestTimeout();
    }
  }

  /**
   * Check if all needed parameters to make the request are set
   */
  allParamsSet (invoice) {
    // Company ID
    if (!InvoiceValidator.validateCustomer(invoice.customerId)) {
      return false;
    }
    // Specification
    if (!InvoiceValidator.validateSpecification(invoice.specification)) {
      return false;
    }
    // Invoice date
    if (!InvoiceValidator.validateInvoiceDate(invoice.invoiceDate)) {
      return false;
    }

    return true;
  }

  startRequestTimeout () {
    if (this.requestTimeout) {
      window.clearTimeout(this.requestTimeout);
    }

    this.requestTimeout = setTimeout(this.makeRequest.bind(this), 500);
  }

  makeRequest () {
    let invoice = this.props.invoice;

    if (this.allParamsSet(invoice)) {
      let params = {
        userId: this.context.user.id,
        customerId: invoice.customerId,
        specification: invoice.specification,
        firstWorkDate: invoice.invoiceDate[0].date,
        lastWorkDate: invoice.invoiceDate[invoice.invoiceDate.length - 1].date,
        languageId: this.props.i18n.locale === 'se' ? 1 : 3
      };

      AgreementDraftService.post(params)
        .then((response) => {
          this.setState({
            agreementDraft: response,
            fetchError: false
          });
        })
        .catch(() => {
          this.setState({
            fetchError: true
          });
        });
    }
  }

  toggleModal (e) {
    let index = 0;

    if (e) {
      e.preventDefault();
      index = parseInt(e.target.parentElement.getAttribute('data-index'));
    }

    this.setState({
      showModal: !this.state.showModal,
      index: index
    });
  }

  renderModal () {
    if (this.state.showModal) {
      return <AgreementDraftModal
        agreementDraft={this.state.agreementDraft[this.state.index]}
        close={this.toggleModal}/>;
    }
  }

  renderPrivacyPolicyDocumentLink () {
    const documentUrl = this.props.i18n.locale === 'en'
      ? '/Bilaga_behandling_av_personuppgifter_ENGELSKA.pdf'
      : '/Bilaga_behandling_av_personuppgifter_SVENSKA.pdf';

    return (
      <a href={documentUrl} target='_blank'>
        <Translate component={'div'} className='terms-text' content='INVOICE_TERMS_AND_CONDITIONS_4'/>
      </a>
    );
  }

  render () {
    if (this.state.fetchError) {
      return (<p className='error'><Translate content='GENERAL_ERROR' component='div'/></p>);
    }

    return (
      <div className='display-inline agreement-draft'>
        <Translate content='HAVE_READ' component='div' className='display-inline'/>
        <a href='#' onClick={this.toggleModal} data-index='1'>
          <Translate component={'div'} className='terms-text' content='INVOICE_TERMS_AND_CONDITIONS_2_INCL'/>
        </a>,
        <a href='#' onClick={this.toggleModal} data-index='0'>
          <Translate component={'div'} className='terms-text' content='INVOICE_TERMS_AND_CONDITIONS_1'/>
        </a>
        <Translate component={'div'} className='terms-text' content='INVOICE_TERMS_AND_CONDITIONS_AND'/>
        {this.renderPrivacyPolicyDocumentLink()}
        {this.renderModal()}
      </div>
    );
  }

}

export default AgreementDraft;




/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/footer/agreement-draft/agreement-draft.js
 **/